import { createSlice } from '@reduxjs/toolkit';
import type { UpNextState, Topic } from './types';

const initialState: UpNextState = {
  isLoading: false,
  isDraftLoading: false,
  error: false,
  upNextTopics: [],
  topicsPagination: {
    total: 0,
    page: 1,
    pageSize: 20,
    draftTopics: [],
    hasMore: true
  }
};

export const slice = createSlice({
  name: 'upNext',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    startDraftLoading(state) {
      state.isDraftLoading = true;
    },
    stopDraftLoading(state) {
      state.isDraftLoading = false;
    },
    hasError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
      state.isDraftLoading = false;
    },
    fetchUpNextTopicsSuccess(state, action) {
      state.upNextTopics = action.payload;
    },
    fetchDraftTopicsSuccess(state, action) {
      const newTopics = action.payload.data.filter(
        (topic: Topic) => !state.upNextTopics.some((ft) => ft.topicGuid === topic.topicGuid)
      );

      const isFirstPage = action.payload.pagination.page === 1;
      state.topicsPagination = {
        ...action.payload.pagination,
        draftTopics: isFirstPage
          ? newTopics
          : [...state.topicsPagination.draftTopics, ...newTopics],
        hasMore:
          action.payload.pagination.page * action.payload.pagination.pageSize <
          action.payload.pagination.total
      };
      state.isDraftLoading = false;
    },
    clearDraftTopics(state) {
      state.topicsPagination.draftTopics = [];
      state.topicsPagination.page = 1;
      state.topicsPagination.hasMore = true;
      state.isDraftLoading = false;
    },
    removeUpNextTopic(state, action) {
      state.upNextTopics = state.upNextTopics.filter(
        (topic) => topic.topicGuid !== action.payload.topicGuid
      );
      state.topicsPagination.draftTopics = [action.payload, ...state.topicsPagination.draftTopics];
    },
    addUpNextTopic(state, action) {
      state.upNextTopics.push(action.payload);
      state.topicsPagination.draftTopics = state.topicsPagination.draftTopics.filter(
        (topic) => topic.topicGuid !== action.payload.topicGuid
      );
    }
  }
});

export default slice.reducer;
